import React, { useMemo, useState } from "react";
import { useRefresh } from "react-admin";
import ExlyFilter from "common/Components/ExlyTable/ExlyTableFilters";
import FaqEditor from "../faqList/FaqEditor";
import Fallback from "../fallBack/FallBack";
import NoResults from "../fallBack/NoResults";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { is_empty } from "../../../../../../utils/validations";
import { constants, tableColumnConfig } from "../../constants";
import { filterConfig, tableChipsFormatter } from "../../constants";
import ExlyModal from "common/Components/ExlyModal";
import { useListController } from "react-admin";
import { Pagination } from "common/Components/Pagination";
import useStyles from "./styles";
import { getParameterByName } from "utils/Utils";
import DraggableTable from "common/Components/DraggableTable";
import ExlyDeleteModal from "common/Components/ExlyDeleteModal/ExlyDeleteModal";
import { handleDelete } from "../helpers";
import { useNotifications } from "utils/hooks";
import { useHandleQuestionOrderChange } from "ui/pages/QuestionsPage/hooks/useHandleQuestionOrderChange";
import { useParams } from "react-router-dom";
import { OFFERING_REORDER_TYPES } from "features/ManageOfferings/constants/ManageOfferings.constants";

const PageBody = (props) => {
  const { showUpload, setShowUpload, offeringLevel } = props;
  const refetch = useRefresh();

  const isDesktop = useDesktopMediaQuery();
  const css = useStyles(isDesktop);

  const { loaded, data, filterValues, page, setPage, total, setFilters } =
    useListController(props);
  const [selectedRecordData, setSelectedRecordData] = useState(null);

  React.useEffect(() => {
    let manageOfferingFilter = getParameterByName("manageOffering");

    if (!is_empty(manageOfferingFilter)) {
      setFilters({ listing__uuid: manageOfferingFilter });
      setSelectedRecordData({ listing__uuid: manageOfferingFilter });
    }
  }, []);

  const { listing_uuid } = useParams();

  // No Data
  const noData = is_empty(data) && loaded && is_empty(filterValues);

  // No Results
  const noSearchResults = !is_empty(filterValues) && is_empty(data);

  // Filter Config
  const _filters = filterConfig();

  const handleDeleteModal = () => setOpenDelete(!openDelete);

  const filterData = useMemo(
    () =>
      Object.values(data)
        .map((obj) => ({ ...obj, _id: obj.uuid }))
        .sort((a, b) => a.priority - b.priority),
    [data]
  );

  const [openDelete, setOpenDelete] = useState(false);
  const { pushNotification } = useNotifications();

  const { handleOrderChange } = useHandleQuestionOrderChange(
    listing_uuid,
    OFFERING_REORDER_TYPES.FAQS
  );

  return (
    <>
      {!noData && !offeringLevel && (
        <ExlyFilter
          onClear={() => {
            setFilters({});
            setSelectedRecordData(null);
          }}
          filters={_filters}
          tabFilterConfig={[]}
          setFilters={setFilters}
          filterValues={filterValues}
          tableChipsFormatter={tableChipsFormatter}
          noExportButton={true}
          isDesktop={isDesktop}
          hasTabs={false}
          hideFilters={false}
        />
      )}
      {noData && (
        <Fallback {...constants.noData} handleBtn={() => setShowUpload(true)} />
      )}
      {!noData && (
        <DraggableTable
          initialData={filterData}
          columnConfig={tableColumnConfig(
            handleDeleteModal,
            setSelectedRecordData,
            setShowUpload
          )}
          onReOrder={handleOrderChange}
          showDragIcon={true}
          customTableStyles={{
            thead: "!tw-bg-[#D8DDE9]",
          }}
        />
      )}
      <ExlyDeleteModal
        title="Delete FAQ"
        deleteBtnText="Confirm"
        description="Are you sure you want to delete the FAQ?"
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={() =>
          handleDelete({
            selectedRecordData,
            setOpenDelete,
            refetch,
            pushNotification,
          })
        }
        onSecondaryBtnClick={() => setOpenDelete(false)}
        padded={false}
      />
      {noSearchResults && <NoResults />}
      <Pagination
        page={page}
        perPage="50"
        onPageChange={setPage}
        total={total}
      />
      <ExlyModal
        title="Add FAQs"
        header="Add FAQs"
        primaryBtnText="Confirm"
        secondaryBtnText="Cancel"
        open={showUpload}
        onClose={() => {
          setShowUpload(false);
          setSelectedRecordData(null);
        }}
        modal_props={{
          customFooter: <></>,
          modalPaperClassName: css.modalPaperClassName,
        }}
        mobile_modal_props={{
          customFooter: <></>,
          paperClassName: "",
        }}
        padded={false}
      >
        {showUpload && (
          <FaqEditor
            refetch={(value) => {
              refetch(value);
            }}
            selectedRecordData={selectedRecordData}
            isModal={true}
            setShowUpload={setShowUpload}
          />
        )}
      </ExlyModal>
    </>
  );
};

export default PageBody;
